import React, { useEffect, useMemo } from 'react';
import { useSound } from './useSound';
import { debounce } from 'lodash';

export const useMessageSound = () => {
  const { load, play } = useSound('assets/message.mp3');

  useEffect(() => {
    load();
  }, [load]);

  return useMemo(() => debounce(() => play(), 5000), [play]);
};

export default useMessageSound;
